'use strict';
import util from './util';
import ajax from './ajax';
import customModal from './modal';
import index from './pages/product/index';

const sampleCookieName = 'sample.selection.shown';

/**
 * Creates sample selection cookie
 */
var createSelectionShownCookieHandler = function () {
	util.setCookie(sampleCookieName, "1");
}

/**
 * Checks if sample selection cookie exists
 * @return {boolean}
 */
var canShowSelectionHandler = function () {
	return (!SitePreferences.SAMPLES_ENABLED) ? false : true;
}

/**
 * Render Samples
 * @return {boolean}
 */
var showSelectionHandler = function () {
	// render content to modal by url
	let urlBase = util.appendParamToURL(Urls.showSampleSelectionInCart, 'format', 'ajax');
	let url = util.appendParamToURL(urlBase);

	$('.ajax-loader').show();
	$.ajax({
		url: url,
		dataType: 'html',
		success: function(response)
		{
			if (response && response.indexOf("error no-selection") == -1) {
				customModal.createCustomModal('bonus-sample-selection', '#modal-custom-placeholder');
				$('.bonus-sample-selection').find('.modal-body').html(response);
				util.bodyPositionFixed('bonus-sample-selection');
			}
			$('.ajax-loader').hide();
		}
	}).done(function(data) {
		if (data && data.responseText && data.responseText.indexOf("error no-selection") == -1) {
			updateModalScrollHandler();
		}
		$('.bonus-sample-selection').find('.modal-body').scrollBox();
	});
}

var showSelectionInCartHandler = function (isNotCart, wasosource) {
	// render content to modal by url
	var sampleID = 'bonus-sample-selection';
	if(typeof(isNotCart) != 'undefined'){
		var url = util.appendParamToURL(Urls.showSampleSelection);
		if(typeof(wasosource) != 'undefined' && wasosource !== true ) {
			url = util.appendParamToURL(url, 'format', 'ajax');
		} else {
			url = util.appendParamToURL(url, 'from', 'waso');
			url = util.appendParamToURL(url, 'format', 'ajax');
		}
	}else {
		var url = util.appendParamToURL(Urls.showSampleSelectionInCart);
		url = util.appendParamToURL(url, 'format', 'ajax');
	}

	$('.sample-container .ajax-loader').show();
	$.ajax({
		url: url,
		dataType: 'html',
		success: function(response)
		{
			customModal.createCustomModal(sampleID);
			$('.' +sampleID ).find('.modal-body').html(response);
			util.bodyPositionFixed(sampleID);
			if(response.indexOf('no-selection') > -1){
				$('.modal-overlay.bonus-sample-selection').addClass('error');
			}
			$('.sample-container .ajax-loader').hide();
		}
	}).done(function(data) {
		updateModalScrollHandler();
		if($('.modal-overlay.bonus-sample-selection').hasClass('error')) {
			setTimeout(function () {
				$('.bonus-sample-selection .modal-body').scrollBox();
			}, 200);
		} else {
			$('.bonus-sample-selection .modal-body').scrollBox();
		}
	});
}

var updateModalScrollHandler = function () {
	$(window).on('resize orientationchange', function() {
		if(!$('.modal-overlay.bonus-sample-selection').hasClass('error')) {
			$('.bonus-sample-selection .sb-content').removeAttr('style');
			$('.bonus-sample-selection .modal-body').scrollBox();
		}
	});
}
var isElementClicked = false;
$(document).on('click', '.pt_cart .sample-container', function(e){
	if ($(this).find('.sample-header-selected').length == 0) {
		showSelectionInCartHandler();
	}
}).on('click', '.sample_at_home' , function(e){
	showSelectionInCartHandler(true, true);
}).on('click','.sample-container .selectsample.desktop-only, .sample-container .selectsample.mobile-only', function () {
	//this is added to handle Edit link click
	showSelectionInCartHandler();
}).on('click','#selectsample',function () {
    isElementClicked = true;
    setTimeout(() => {
        isElementClicked = false;
    }, 2000);
});

$(document).on('click', '.sample-container', function(e){
	if ($(this).find('.sample-header-selected').length > 0 && isElementClicked == false) {
		$('.sample-tiles-container').slideToggle();
		$(this).find('.icon-upCarrot').toggleClass('change-down');
		$(this).closest('.sample-container').toggleClass('active');
	}
})

export default {
	createSelectionShownCookie: createSelectionShownCookieHandler,
	canShowSelection: canShowSelectionHandler,
	showSelection: showSelectionHandler,
	showSelectionInCart: showSelectionInCartHandler,
	updateModalScroll: updateModalScrollHandler
};